import { render, staticRenderFns } from "./InspectionDialog.vue?vue&type=template&id=366accf6"
import script from "./InspectionDialog.vue?vue&type=script&lang=js"
export * from "./InspectionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports